import { render } from "./CourseDepartments.vue?vue&type=template&id=74e9c5d3"
import script from "./CourseDepartments.vue?vue&type=script&lang=js"
export * from "./CourseDepartments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CourseDepartments/CourseDepartments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74e9c5d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74e9c5d3', __exports__)) {
    api.reload('74e9c5d3', __exports__)
  }
  
  module.hot.accept("./CourseDepartments.vue?vue&type=template&id=74e9c5d3", () => {
    api.rerender('74e9c5d3', render)
  })

}


export default __exports__